module.exports = __webpack_public_path__ + "static/media/whyDangerous.d3b4a325.mp3";